import {
  TListingFetchReason,
  TRESPONSE_FLOATING_AREAS_FOR_LOCATION_DELETION,
  TRESPONSE_GET_ASSSIGN_EMPLOYEE_DROPDOWN,
  TRESPONSE_GET_LOCAL_NEEDLE_STORES,
  TRESPONSE_LOCATION_LIST,
} from '@monorepo/types';
import { TUserPaginationOption } from '@monorepo/ui';

export type TLocationManagementState = {
  locationListingInfo: {
    res: TRESPONSE_LOCATION_LIST;
    fetchReason: TListingFetchReason;
  } | null;
  assignEmployeeDropdown: TRESPONSE_GET_ASSSIGN_EMPLOYEE_DROPDOWN | null;
  floatingAreaFloorsForLocationDeletion: TRESPONSE_FLOATING_AREAS_FOR_LOCATION_DELETION | null;
  localNeedleStoresInfo: TRESPONSE_GET_LOCAL_NEEDLE_STORES | null;
  locationListingPagination: TUserPaginationOption;
};

export const TLocationManagementGetFloatingAreaActionTypes = {
  GetFloatingAreaFloorsForLocationDeletion: 'GET_FLOATING_AREA_FLOORS_FOR_LOCATION_DELETION' as const,
  GetFloatingAreaFloorsForLocationDeletionSuccess: 'GET_FLOATING_AREA_FLOORS_FOR_LOCATION_DELETION_SUCCESS' as const,
  GetFloatingAreaFloorsForLocationDeletionFailure: 'GET_FLOATING_AREA_FLOORS_FOR_LOCATION_DELETION_FAILURE' as const,
};

export const TLocationManagementActionType = {
  ...TLocationManagementGetFloatingAreaActionTypes,
  GetLocationList: 'GET_LOCATION_LIST' as const,
  GetLocationListSuccess: 'GET_LOCATION_LIST_SUCCESS' as const,
  GetLocationListFailure: 'GET_LOCATION_LIST_FAILURE' as const,
  SetLocationListPagination: 'SET_LOCATION_LIST_PAGINATION' as const,
  DeleteLocations: 'DELETE_LOCATION' as const,
  DeleteLocationsSuccess: 'DELETE_LOCATION_SUCCESS' as const,
  DeleteLocationsFailure: 'DELETE_LOCATION_FAILURE' as const,
  UpdateLocationManagementPageNo: 'LOCATION_LIST_ACTION_UPDATE_PAGE_NO' as const,
  UpdateLocationManagementItemsPerPage: 'LOCATION_LIST_ACTION_UPDATE_ITEMS_PER_PAGE' as const,
  AssignEmployee: 'ASSIGN_EMPLOYEE' as const,
  AssignEmployeeSuccess: 'ASSIGN_EMPLOYEE_SUCCESS' as const,
  AssignEmployeeFailure: 'ASSIGN_EMPLOYEE_FAILURE' as const,
  AssignEmployeeDropdown: 'ASSIGN_EMPLOYEE_DROPDOWN' as const,
  AssignEmployeeDropdownSuccess: 'ASSIGN_EMPLOYEE_DROPDOWN_SUCCESS' as const,
  AssignEmployeeDropdownFailure: 'ASSIGN_EMPLOYEE_DROPDOWN_FAILURE' as const,
  GetLocalNeedleStores: 'GET_LOCAL_NEEDLE_STORES' as const,
  GetLocalNeedleStoresSuccess: 'GET_LOCAL_NEEDLE_STORES_SUCCESS' as const,
  GetLocalNeedleStoresFailure: 'GET_LOCAL_NEEDLE_STORES_FAILURE' as const,
  AssignNeedleStores: 'ASSIGN_NEEDLE_STORES' as const,
  AssignNeedleStoresSuccess: 'ASSIGN_NEEDLE_STORE_SUCCESS' as const,
  AssignNeedleStoresFailure: 'ASSIGN_NEEDLE_STORES_FAILURE' as const,
};
